import { Box, Typography, useTheme } from "@mui/material";
import React from "react";

export interface EmptyStateProps {
  title: string;
  Icon: React.ReactNode;
  message?: string;
  height?: string;
}

function EmptyState(props: EmptyStateProps) {
  const { message, Icon, title, height = "auto" } = props;
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        borderRadius: theme.spacing(1),
        padding: theme.spacing(10),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: theme.spacing(2),
        minHeight: 200,
        height: height,
      }}
    >
      <Box
        sx={{
          backgroundColor: theme.palette.background.paper,
          padding: theme.spacing(3),
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {Icon}
      </Box>

      <Typography variant="label1R" fontWeight={600} color="grey.80">
        {title}
      </Typography>

      {message && (
        <Typography variant="label1R" color="grey.60">
          {message}
        </Typography>
      )}
    </Box>
  );
}

export default EmptyState;
